const rawApiBaseUrl = process.env.REACT_APP_API_BASE_URL;

if (!rawApiBaseUrl) {
  throw new Error("REACT_APP_API_BASE_URL undefined.");
}

const normalizedApiBaseUrl = rawApiBaseUrl.replace(/\/+$/, "");
const hasApiSuffix = /\/api$/i.test(normalizedApiBaseUrl);

export const API_BASE_URL = hasApiSuffix
  ? normalizedApiBaseUrl
  : `${normalizedApiBaseUrl}/api`;

export const API_ORIGIN = hasApiSuffix
  ? normalizedApiBaseUrl.replace(/\/api$/i, "")
  : normalizedApiBaseUrl;

const trimLeadingSlash = (path: string) => path.replace(/^\/+/, "");

export const apiUrl = (path: string) => `${API_BASE_URL}/${trimLeadingSlash(path)}`;

export const apiOriginUrl = (path: string) =>
  `${API_ORIGIN}/${trimLeadingSlash(path)}`;



// WEBPACK FOOTER //
// ./src/config/api.ts